import Constants from "./constants";

export function validateRosaLimits(current, changes, squadre, calciatori, tipoRuoli = "classic") {
  if (!changes) return;
  const next = { ...current, ...changes };
  if (!["=", "<=", ">=", "illimitati"].includes(next.op) ||
      (tipoRuoli === "mantra" && next.op !== "illimitati")) {
    const error = new Error(tipoRuoli === "mantra"
      ? "Con i ruoli Mantra la composizione rosa deve restare A piacere / Illimitati."
      : "Modalità di composizione rosa non valida.");
    error.code = "ROSA_LIMIT_INVALID";
    throw error;
  }
  if (next.op === "illimitati") return;
  const hasMaximum = next.op === "=" || next.op === "<=";

  const conflicts = [];
  for (const ruolo of Object.values(Constants.RUOLI_NEW)) {
    if (current.op === next.op && Number(current[ruolo.n]) === Number(next[ruolo.n])) continue;
    const limit = Number(next[ruolo.n]);
    if (!Number.isInteger(limit) || limit < 0) {
      const error = new Error("Numero di " + ruolo.plurale.toLowerCase() + " non valido.");
      error.code = "ROSA_LIMIT_INVALID";
      throw error;
    }
    if (!hasMaximum) continue;
    for (const [id, squadra] of Object.entries(squadre || {})) {
      const count = Object.keys(squadra.calciatori || {}).filter(playerId =>
        calciatori[playerId] && Number(calciatori[playerId].ID_Ruolo) === ruolo.ruolo_id
      ).length;
      if (count > limit) {
        conflicts.push(`${squadra.name || id}: ${count} ${ruolo.plurale.toLowerCase()} acquistati, nuovo limite ${limit}.`);
      }
    }
  }
  if (conflicts.length) {
    const error = new Error("Non puoi impostare meno posti dei calciatori già acquistati.\n\n" + conflicts.join("\n"));
    error.code = "ROSA_LIMIT_CONFLICT";
    throw error;
  }
}
